module.exports = __webpack_public_path__ + "static/media/ico_wallet_512.13f2ea6c.png";